import {
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RECAPTCHA_LANGUAGE, RecaptchaModule } from 'ng-recaptcha-2';

import { AccountModule } from './account/account.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplicationModule } from './application/application.module';
import { AuthModule } from './auth/auth.module';
import { CoreModule } from './core/core.module';
import { CreditsComponent } from './credits/credits.component';
import { HomeComponent } from './home/home.component';
import { ProgramModule } from './program/program.module';
import { ProviderModule } from './provider/provider.module';
import { ScrollScreenDirective } from './shared/directives';
import { GoogleAnalyticsService } from './shared/service/google-analytics.service';
import { SharedModule } from './shared/shared.module';
import { PrivacyPolicyComponent, TermsOfUseComponent } from './support';
import { HelpComponent } from './support/help/help.component';
import { SupportModule } from './support/support.module';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HelpComponent,
        PrivacyPolicyComponent,
        TermsOfUseComponent,
        ScrollScreenDirective,
        CreditsComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        SharedModule,
        ProgramModule,
        ApplicationModule,
        ProviderModule,
        AccountModule,
        AuthModule,
        MatNativeDateModule,
        SupportModule,
        RecaptchaModule,
        AppRoutingModule
    ],
    providers: [
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: sessionStorage.getItem('selectedLanguage') ?? 'en'
        },
        GoogleAnalyticsService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
